<template>
  <div id="sc-shipping-cost">
    <p class="text-size-20">STOCKCREW倉庫から出荷した商品に対する費用明細を確認いただけます。</p>
    <div class="panel-body">
      <expense-detail-table
        :url="'/Warehouse/sc/expense/shipping-cost'"
        :method="'get'"
        :columns="$options.columns"
        :searchValue="filters"
        :paginationStorageKey="'scShippingCost'"
        @updateFilters="updateFilters"
        @onHandleSearch="onHandleSearch"
        @confirmDownloadCsv="openModalConfirmDownloadCsv"
        ref="scShippingCostTable"
      >
        <template slot="shippingDate" slot-scope="props">
          <span>{{ formatDate(props.rowData.shippingDate) }}</span>
        </template>
        <template slot="detail" slot-scope="props">
          <div v-html="props.rowData.detail" class="mr-r-5"></div>
        </template>
        <template slot="size" slot-scope="props">
          <span>{{ props.rowData.size }}</span>
        </template>
        <template slot="costNoTax" slot-scope="props">
          <span>{{ formatAmount(props.rowData.costNoTax) }}</span>
        </template>
        <template slot="cost" slot-scope="props">
          <span>{{ formatAmount(props.rowData.cost) }}</span>
        </template>
      </expense-detail-table>

      <modal-confirm-download-csv
        v-if="showModalConfirmDownloadCsv"
        :message="`費用明細（出荷実績）CSVをダウンロードします。<br> よろしければ「ダウンロード」ボタンを押してください。`"
        @close="closeModalConfirmDownloadCsv"
        @downloadCsv="handleDownloadCsv"
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import ExpenseDetailTable from './components/ExpenseDetailTable'
import Util from '@/common/utility'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import ModalConfirmDownloadCsv from '@/view/deliveryRequests/components/ModalConfirmDownloadCsv'
import WarehouseScService from '@/services/warehousescservice'

export default {
  props: {
    currentTab: {
      type: String,
      default: ''
    }
  },
  components: {
    ExpenseDetailTable,
    ModalConfirmDownloadCsv
  },
  data () {
    return {
      showModalConfirmDownloadCsv: false,
      filters: {
        detail: null,
        from: null,
        to: null
      }
    }
  },
  columns: [
    {
      title: '出荷確定日時',
      name: 'shippingDate',
      cellClass: '',
      headerClass: 'text-center w-200'
    },
    {
      title: '明細',
      name: 'detail',
      cellClass: '',
      headerClass: 'text-center header-detail'
    },
    {
      title: '配送サイズ',
      name: 'size',
      cellClass: '',
      headerClass: 'text-center w-150'
    },
    {
      title: '運賃等合計(税抜)',
      name: 'costNoTax',
      cellClass: 'text-right',
      headerClass: 'text-center w-150'
    },
    {
      title: '運賃等合計(税込)',
      name: 'cost',
      cellClass: 'text-right',
      headerClass: 'text-center w-150'
    }
  ],
  mounted () {
    let logParams = {
      name: eventCode.warehouse_sc.expense_details_tab.shipping_cost.show,
      properties: {}
    }
    EventService.postTrackLog(logParams)

    let self = this
    this.$events.listen('apiSuccess', (url) => {
      if (url === '/Warehouse/sc/expense/shipping-cost') {
        self.loader && self.loader.hide()
      }
    })
  },
  methods: {
    formatAmount (value) {
      return `¥${Util.formatMoney(value)}`
    },
    formatDate (value) {
      return value ? moment(value).format('YYYY/MM/DD HH:mm:ss') : null
    },
    updateFilters (filters) {
      this.filters = filters
    },
    onHandleSearch () {
      let logParams = {
        name: eventCode.warehouse_sc.expense_details_tab.shipping_cost.click_search_btn,
        properties: this.filters
      }
      EventService.postTrackLog(logParams)
    },
    async handleDownloadCsv () {
      let logParams = {
        name: eventCode.warehouse_sc.expense_details_tab.shipping_cost.click_download_btn,
        properties: {}
      }
      EventService.postTrackLog(logParams)

      let sellerId = this.$store.getters.getUser.sellerId
      let reportTime = moment(new Date()).format('YYYYMMDDHHmmss')
      let filename = `stockcrewWarehouse_shippingCost_${sellerId}_${reportTime}.csv`
      let params = {
        sellerId: sellerId,
        detail: this.filters.detail,
        from: this.filters.from,
        to: this.filters.to
      }

      this.closeModalConfirmDownloadCsv()
      await WarehouseScService.exportShippingCost(params, filename)
        .then(response => {
        })
        .catch(error => {
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    openModalConfirmDownloadCsv () {
      this.showModalConfirmDownloadCsv = true
    },
    closeModalConfirmDownloadCsv () {
      $('#confirm-download-cvs-modal').modal('hide')
      this.showModalConfirmDownloadCsv = false
    }
  }
}
</script>

<style scoped>
  #sc-shipping-cost /deep/ .panel-body {
    background-color: #fff;
    border: 1px solid #ccc;
  }
@media (max-width: 1200px) {
  #sc-shipping-cost /deep/ .table-wrapper {
    width: 100%;
    overflow-y: hidden;
    overflow-x: auto;
  }
  #sc-shipping-cost /deep/ .table {
    width: max-content;
    max-width: max-content;
  }
  #sc-shipping-cost /deep/ .header-detail {
    width: 500px;
  }
  #sc-shipping-cost /deep/ .box-base-table-search {
    display: block;
    justify-content: unset;
    align-items: unset;
    flex-wrap: unset;
  }
  #sc-shipping-cost /deep/ .box-base-table-search .sale-detail-search {
    display: block;
  }
  #sc-shipping-cost /deep/ .box-base-table-search .search-block {
    display: block;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseSc/ShippingCost.vue